"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGeniusForPersonality = exports.createFromGenius = void 0;
const article_1 = __importDefault(require("./article"));
const details_1 = require("./details");
const list_1 = require("./list");
/**
 * Create the Markdown only summary from the Genius resources.
 * @param source The source.
 * @param level The heading level.
 */
const fromGeniusOnlySummary = (source, level) => list_1.line(article_1.default({ body: source.summary, head: source.name, level }), list_1.list(...source.detail));
/**
 * Create the Markdown only descriptions from the Genius resources.
 * @param descriptions The resource of tne description.
 * @param source The source.
 * @param level The heading level.
 */
const fromGeniusOnlyDesctiption = ({ strategy, weak }, source, level) => list_1.line(...[
    { head: strategy, body: list_1.list(...source.strategy) },
    { head: weak, body: list_1.list(...source.weak) },
].map((options) => article_1.default({ ...options, level })));
/**
 * Create the Markdown from the Genius resources.
 * @param descriptions The resource of tne description.
 */
const createFromGenius = (descriptions) => 
/**
 * @param source The source.
 * @param level The heading level.
 */
(source, level) => list_1.line(fromGeniusOnlySummary(source, level), fromGeniusOnlyDesctiption(descriptions, source, level + 1));
exports.createFromGenius = createFromGenius;
/**
 * Create the Markdown from the Genius resources.
 * @param source The source.
 * @param accessors The accessors instance for resources.
 */
const fromGeniusForPersonality = (source, accessors) => {
    const descriptions = accessors.getDescription();
    const { descriptions: { inner, outer, workStyle }, ...details } = accessors.genius.getCategoryDetail();
    return list_1.line(details_1.detailsBase({ addition: descriptions.genius1, src: details }), list_1.order(inner, outer, workStyle), descriptions.genius2, ...[
        [exports.createFromGenius(descriptions), source.inner, inner],
        [fromGeniusOnlySummary, source.outer, outer],
        [fromGeniusOnlySummary, source.workStyle, workStyle],
    ].map(([fn, type, head]) => article_1.default({ body: fn(accessors.genius.getByKey(type), 4), head, level: 3 })));
};
exports.fromGeniusForPersonality = fromGeniusForPersonality;
//# sourceMappingURL=genius.js.map